export const actieLogs = state => state.actieLogs;
export const inzageLogs = state => state.inzageLogs;
export const loginLogs = state => state.loginLogs;
export const users = state => state.users;
